import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, Loader2, ArrowLeft } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem('admin_token', data.token);
        navigate('/admin');
      } else {
        const detail = data.detail;
        setError(typeof detail === 'string' ? detail : Array.isArray(detail) ? detail.map(e => e.msg || e).join(' ') : 'Identifiants incorrects');
      }
    } catch (err) {
      setError('Erreur de connexion au serveur');
    } finally {
      setLoading(false);
    }
  }, [email, password, navigate]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-2xl text-[#C5A059] font-light tracking-wider" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            INTERFLEX
          </h1>
          <p className="text-white/40 text-xs uppercase tracking-widest mt-1">Administration</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#0a0a0a] border border-white/10 p-8 space-y-5" data-testid="admin-login-form">
          {error && (
            <div className="bg-red-500/10 border border-red-500/20 text-red-400 text-sm p-3" data-testid="login-error">
              {error}
            </div>
          )}

          <div>
            <label className="text-white/40 text-xs uppercase tracking-wider flex items-center gap-2 mb-2">
              <Mail size={12} />Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#111] border border-white/10 text-white px-4 py-3 text-sm focus:border-[#C5A059] focus:outline-none transition-colors"
              placeholder="admin@interflex.com"
              required
              data-testid="admin-email-input"
            />
          </div>

          <div>
            <label className="text-white/40 text-xs uppercase tracking-wider flex items-center gap-2 mb-2">
              <Lock size={12} />Mot de passe
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#111] border border-white/10 text-white px-4 py-3 text-sm focus:border-[#C5A059] focus:outline-none transition-colors"
              placeholder="••••••••"
              required
              data-testid="admin-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#C5A059] text-black py-3 text-sm font-medium hover:bg-[#D4AF63] transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
            data-testid="admin-login-btn"
          >
            {loading ? <Loader2 className="animate-spin" size={16} /> : <Lock size={16} />}
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <button
          onClick={() => navigate('/')}
          className="mt-6 text-white/30 text-xs flex items-center gap-1 mx-auto hover:text-white/50 transition-colors"
          data-testid="back-to-site-btn"
        >
          <ArrowLeft size={12} />
          Retour au site
        </button>
      </div>
    </div>
  );
}
